import { Injectable } from '@angular/core';
import { Observable, observable } from 'rxjs';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {
  rootScopeData:RootScopeDeclare;

  constructor(private httpclient :HttpClient,private httpHeaderService: HttpHeadersService, private rootScopeService:RootScopeService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }


  post(userEmail: string):Observable <any>{
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    return this.httpclient.post(environment.servicePath+"/lfuser/forgot_password?email="+userEmail,{}, { headers: headers, observe:'response'});
  
  
  }
}
